import { render } from "./MultiLanguageDropdown.vue?vue&type=template&id=02e52e1c"
import script from "./MultiLanguageDropdown.ts?vue&type=script&lang=js"
export * from "./MultiLanguageDropdown.ts?vue&type=script&lang=js"

import "./MultiLanguageDropdown.vue?vue&type=style&index=0&id=02e52e1c&lang=css"

import exportComponent from "/Users/r.hutter/Resilio Sync/_Workspace/git/TitleTool-NG/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__